import { Box, Divider, Flex, Text } from "@chakra-ui/react";

const InfluencerInvoiceComponent = ({ invoiceData }) => {
  const {
    companyName,
    companyAddress,
    brandRepName,
    brandRepEmail,
    creatorName,
    deliverables,
    paymentTerms,
    totalAmount,
    link,

    InvoiceNumber,
    payeesName,
    bankName,
    accountNumber,
    routingNumber,
    swiftCode,
    paypalEmail,
    zelleEmail,
    wire,
    CreatorPayout,
  } = invoiceData;

  const currentDate = new Date().toLocaleDateString();

  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(CreatorPayout);

  const links = link.split(/[\s,;]+/).filter((link) => link.trim().length > 0);

  return (
    <Flex width="100%" className="invoice-container">
      <Box
        className="invoice-content"
        flex="1"
        maxWidth="800px"
        margin="0 auto"
        padding="20px"
      >
        {/* Header */}
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          marginBottom="20px"
        >
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", margin: 0 }}>
            INVOICE
          </h1>
        </Box>

        {/* Details */}
        <Flex
          className="invoice-details"
          justifyContent="flex-start"
          alignItems="center"
          flexDirection="row"
          flexWrap="wrap"
          gap="20px"
          marginBottom="20px"
        >
          <Box
            className="invoice-number"
            marginBottom={{ base: "10px", md: "0" }}
          >
            <Flex alignItems="center">
              <Box
                width="4px"
                height="30px"
                marginRight="12px"
                borderRight="2px solid black"
              />
              <Box className="label" fontWeight="bold" marginRight="8px">
                <h2>INVOICE#:</h2>
              </Box>
              <span>{InvoiceNumber}</span>
            </Flex>
          </Box>

          <Box className="invoice-date">
            <Flex alignItems="center">
              <Box
                width="4px"
                height="30px"
                marginRight="12px"
                borderRight="2px solid black"
              />
              <Box className="label" fontWeight="bold" marginRight="8px">
                <h2>DATE ISSUED:</h2>
              </Box>
              <span>{currentDate}</span>
            </Flex>
          </Box>
        </Flex>

        {/* Customer Info */}
        <Box
          border="1px solid #e0e0e0"
          borderRadius="4px"
          padding="15px"
          marginBottom="20px"
        >
          <Box marginBottom="10px">
            <Flex alignItems="center">
              <h1
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  minWidth: "80px",
                }}
              >
                CUSTOMER DETAILS:
              </h1>
              <p>{companyName}</p>
            </Flex>
          </Box>
          <Box marginBottom="10px">
            <Flex alignItems="center">
              <h3 style={{ fontWeight: "bold", minWidth: "80px" }}>Contact:</h3>
              <p>{brandRepName}</p>
            </Flex>
          </Box>
          <Box mb="10px">
  <Box  p="2">
    <Text as="span" fontWeight="bold">
      Company Address:
    </Text>{' '}
    <Text as="span" whiteSpace="pre-wrap">
      {companyAddress}
    </Text>
  </Box>
</Box>


          <Box>
            <Flex alignItems="center">
              <h3 style={{ fontWeight: "bold", minWidth: "110px" }}>
                Email/Phone:
              </h3>
              <p>{brandRepEmail}</p>
            </Flex>
          </Box>
        </Box>

        {/* Campaign Table */}
      <Box className="campaign-table" marginBottom="20px" overflowX="auto">
      <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid black" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid black", background: "black", color: "white" }}>
            <th
              style={{
                width: "35%",
                padding: "10px",
                textAlign: "left",
                border: "1px solid black",
              }}
            >
              Creator's Name
            </th>
            <th
              style={{
                padding: "10px",
                textAlign: "left",
                border: "1px solid black",
              }}
              colSpan="2"
            >
              Campaign Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ borderBottom: "1px solid black" }}>
            <td style={{ padding: "10px", verticalAlign: "top", border: "1px solid black" }}>
              <p>{creatorName}</p>
            </td>
            <td style={{ padding: "10px", border: "1px solid black" }} colSpan="2">
              <div style={{ fontSize: "14px", marginBottom: "8px" , letterSpacing: "0.3px",
          lineHeight: "1.5"}}>{deliverables}</div>
              {links.length > 0 && (
                <Flex wrap="wrap" gap="8px" marginTop="8px">
                  {links.map((url, idx) => (
                    <a
                      key={idx}
                      className="invoice-link"
                      href={/^https?:\/\//.test(url) ? url : `https://${url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "14px",
                        color: "#0066cc",
                        textDecoration: "none",
                      }}
                    >
                      {url}
                    </a>
                  ))}
                </Flex>
              )}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "10px", border: "1px solid black" }}>
              <b style={{ display: "block", marginBottom: "5px" }}>Payment Terms:</b>
              <p>{paymentTerms}</p>
            </td>
            <td
              style={{
                padding: "10px",
                fontWeight: "bold",
                verticalAlign: "top",
                border: "1px solid black",
              }}
            >
              Total Amount
            </td>
            <td
              style={{
                padding: "10px",
                fontWeight: "bold",
                verticalAlign: "top",
                border: "1px solid black",
              }}
            >
              {formattedAmount}
            </td>
          </tr>
        </tbody>
      </table>
    </Box>


        {/* Payment Info */}
        <Box>
          <Flex alignItems="center">
            <Box
              width="4px"
              height="30px"
              marginRight="12px"
              borderRight="2px solid black"
            />
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "20px",
                paddingBottom: "5px",
              }}
            >
              PAYMENT TO 
            </h2>
          </Flex>{" "}
      <Box padding="10px">
  <Flex marginBottom="8px">
    <span>
      <strong>Bank of America:</strong> {bankName}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>Payee Name:</strong> {payeesName}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>Account No (USD):</strong> {accountNumber}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>Routing (ACH):</strong> {routingNumber}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>Wires (Domestic):</strong> {wire}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>SWIFT (International/USD):</strong> {swiftCode}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>Zelle Email:</strong> {zelleEmail}
    </span>
  </Flex>
  <Flex marginBottom="8px">
    <span>
      <strong>Paypal Email:</strong> {paypalEmail}
    </span>
  </Flex>
</Box>

        </Box>
      </Box>
    </Flex>
  );
};

export default InfluencerInvoiceComponent;
